export default __webpack_public_path__ + "static/media/fisherman.111990ba.png";